import React from 'react';
import { useLocation } from 'react-router-dom';
import { useShellSidebarContext } from '@/contexts/ShellSidebarContext';
import { isDeskPath, isLibraryPath } from '@/constants/appRoutes';

/**
 * Feature sidebar (sessions, facets, projects, …).
 * Hidden on Desk / RCM Library and whenever no feature registered content.
 * Brand + product switching live on ShellTabBar.
 */
export function ShellLeftRail() {
  const { content } = useShellSidebarContext();
  const { pathname } = useLocation();

  if (isDeskPath(pathname) || isLibraryPath(pathname) || content == null) {
    return null;
  }

  return (
    <aside className="shell-left-rail hidden lg:flex min-h-0 flex-col border-r border-[var(--rcm-color-border)] bg-[var(--rcm-color-sidebar)]">
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{content}</div>
    </aside>
  );
}
